import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingBeefPrimaryData, setFootprintingBeefPrimaryDataAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_AUTOFILL_APPLIED, FOOTPRINTING_BEEF_PRIMARY_DATA } from "consts";

import { FootprintingBeefPrimaryData } from "models";

export type CreateBeefPrimaryDataQueryParams = {
  autofillYear?: number;
};

export const useMutateFootprintingBeefPrimaryData = (
  farmId: string,
  year: number,
  payload: Omit<FootprintingBeefPrimaryData, "id">,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const setPrimaryData = isAdmin ? setFootprintingBeefPrimaryDataAdmin : setFootprintingBeefPrimaryData;
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_BEEF_PRIMARY_DATA, primaryDataId, isAdmin],
      mutationFn: (qps?: CreateBeefPrimaryDataQueryParams) =>
        qps?.autofillYear ? setPrimaryData(payload, primaryDataId, qps) : setPrimaryData(payload, primaryDataId),
      onSuccess: async (_data, variables) => {
        if (variables?.autofillYear) {
          queryClient.setQueryData([FOOTPRINTING_AUTOFILL_APPLIED, "beef", farmId, year], true);
        }
        invalidateAndRefecthQueries(queryClient, [...footprintingBeefPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin)]);
      },
    },
    queryClient
  );
};
